/**
 * App.tsx — root router shell.
 *
 * Route structure:
 *   /          → Home  (no Layout wrapper — standalone marketing page)
 *   /login     → Login (no Layout wrapper — centered auth card)
 *   /abuse     → Abuse (no Layout wrapper — standalone form)
 *   /inbox/*   → Layout wraps Outlet (authenticated shell)
 *   /account/* → Layout wraps Outlet
 *   /admin/*   → Layout wraps Outlet
 *
 * All pages use Tailwind + custom primitives (MUI removed in M4.1).
 */

import { Outlet } from 'react-router-dom';
import { Layout } from './components/Layout';

/** Shell for routes that need the authenticated Layout. */
export function LayoutShell() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

/** Default export kept for backward compatibility with existing lazy imports. */
export default function App() {
  // This component is no longer used directly; routing is now handled
  // via LayoutShell + standalone page routes in main.tsx.
  return <Outlet />;
}
